<template>
  <div class="dialog" v-if="isBuilding">
    <div class="main">
      <div class="dialog_content">功能维护中，暂未开放</div>
      <div><button @click="isBuilding = false">确定</button></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBuilding: false
    };
  },
  methods: {
    handleShow() {
      this.isBuilding = true;
    },
    handleClose() {
      this.isBuilding = false;
    }
  }
};
</script>

<style scoped lang="scss">
.dialog {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  z-index: 2;
  .main {
    margin: 0 auto;
    border-radius: 4px;
    background: #fff;
    width: 300px;
    height: 150px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    .dialog_content {
      color: #000;
    }
    button {
      outline: none;
      width: 100px;
      background-color: #3a61b1;
      border: 1px solid #666;
      border-radius: 4px;
      padding: 5px;
      cursor: pointer;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommingSoon.vue